<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Categorías</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="row">
          <div class="col-md-6">

          </div>

          <div class="col-md-6">

            <div class="text-right" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
              <router-link to="/admin-panel/categorias/create">
                <b-button variant="primary">
                  <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Crear Categoría
                </b-button>
              </router-link>
            </div>

          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <b-table striped hover :items="categoryItems" :fields="fields">

              <template #cell(deleted)="data">
                <span v-if="data.item.deleted">Sí</span>
                <span v-else>No</span>
              </template>

              <!-- A virtual column -->
              <template #cell(actions)="data" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                <b-dropdown id="dropdown-1" text="Acciones" class="m-md-1">
                  <b-dropdown-item>
                    <router-link :to="{ name: 'CategoryEdit', params: { id: data.item.id}}" >
                      <font-awesome-icon icon="fas fa-edit" />&nbsp;Editar
                    </router-link>
                  </b-dropdown-item>

                  <b-dropdown-item  v-if="!data.item.deleted || data.item.deleted == false" @click="deleteCategories(data.item.id)">
                    <a href="#"><font-awesome-icon icon="fas fa-trash" />&nbsp;Eliminar</a>
                  </b-dropdown-item>

                </b-dropdown>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"

            ></b-pagination>
          </div>
        </div>
      </div>
      <div v-if="userPermission === 'ROLE_ADMIN' || userPermission === 'ROLE_ENABLING_TEACHER'">

      <!-- DataTales Example -->




    </div>
  </div>
    <!-- /.container-fluid -->

  </div>
  <!-- End of Main Content -->
</template>

<script>
import axios from "axios";

export default {
  name: "CategoriesAdmin",
  data: () => {
    return {
      fields: [
        {
          key: 'description',
          sortable: true,
          label: "Titulo",
          class: 'w-25'
        },
        {
          key: 'deleted',
          label: 'Eliminado',
          sortable: false,
          class: 'w-25'
        },
        {
          key: 'actions',
          label: '',
          sortable: true,
          class: 'w-25'
        }
      ],
      categoryItems: [],
      categoriesInactiveItems: [],
      currentPage: 1,
      rows: 10000,
      perPage: 10,
      selectedStatus: "list",
      userPermission: ''
    }
  },
  methods: {
    deleteCategories(id) {
      if(!confirm("¿Estás seguro que deseas eliminar esta Categoria?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/categories/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.loadCategories()
          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    loadCategories() {
      let tmpCurrentpage = this.$route.query.currentPage;
      let loader = this.$loading.show({});
      let categoryStatus = this.selectedStatus;

      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/categories/" + categoryStatus, {
          params: {
            page: this.currentPage,
            size: this.perPage,
            sort: "DESC",
            search: this.search,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loader.hide();
          this.categoryItems = response.data;
          this.rows = response.data.totalElements;
          if (this.$route.query.currentPage) {
            this.$nextTick(function () {
              this.currentPage = tmpCurrentpage;
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
  },
  beforeMount() {

  },
  watch: {
    currentPage: function () {
      this.loadCategories()
    }
  },
  mounted() {
    this.userPermission =  localStorage.getItem("role")
    this.loadCategories();
  }
};
</script>

<style scoped>

</style>
